export default __webpack_public_path__ + "static/media/baby-36.9bda9131.svg";